import "index.scss"
import "syntax-highlighting.css"
import Bulmatown from "bulmatown"

// Import all JavaScript & CSS files from src/_components
import components from "bridgetownComponents/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
